module.exports = __webpack_public_path__ + "img/1.05d1c459.png";